import { FormEvent, useEffect, useState } from 'react';
import { useRouter } from 'next/compat/router';
import styled from 'styled-components';

import { MEMBER_INFO_PATH } from '@pass-frontend/common/constants/paths';
import { useIntl } from '@pass-frontend/common/i18n';
import { env } from '@pass-frontend/features/configuration/util';
import { useMemberCode } from '@pass-frontend/features/facility-checkin/data-bridge';
import { RdsButton } from '@pass-frontend/rally-energon-react';
import { RESPONSIVE_QUERY } from '@pass-frontend/utility/style-helpers';

import { ErrorInfo } from '../error-info';

const StyledCodeLookup = styled.div``;

const PartnerInput = styled.input`
  width: 100%;
  height: 40px;
`;

const PartnerButton = styled(RdsButton)`
  width: 130px;

  ${RESPONSIVE_QUERY.medium} {
    width: 100%;
  }
`;

export function CodeLookup() {
  const [memberCodeError, setMemberCodeError] = useState(false);
  const { ENABLE_FACILITY_CODE_CHECK } = env();
  const [code, setCode] = useState('');
  const router = useRouter();
  const { fetchMemberByCode, memberCheckForCode } = useMemberCode();
  const { t } = useIntl();

  const onCodeSubmit = async (event: FormEvent) => {
    setMemberCodeError(false);
    event?.preventDefault();
    if (code) {
      fetchMemberByCode(code.toUpperCase());
    } else {
      setMemberCodeError(true);
    }
  };

  const handleCodeChange = (event: FormEvent) => {
    setCode((event.target as HTMLInputElement).value.trim());
    setMemberCodeError(false);
  };

  useEffect(() => {
    if (memberCheckForCode?.status === 'noMatch') {
      setMemberCodeError(true);
    } else if (memberCheckForCode?.status === 'matchFound') {
      router?.push(MEMBER_INFO_PATH);
    }
  }, [memberCheckForCode]);

  return (
    <StyledCodeLookup>
      <div>
        <div>
          <h6 className="has-rds-mt-24 has-rds-mb-16 is-rds-h6 has-rds-font-weight-medium">
            Verify code
          </h6>
        </div>
        <div className="large-box has-rds-bg-white has-rds-p-24 has-rds-radius-4 has-rds-box-shadow-neutral-spread-6 is-rds-body-4 has-rds-font-weight-semibold">
          {ENABLE_FACILITY_CODE_CHECK ? (
            <p
              data-testid="verify-code"
              className="is-rds-body-3 has-rds-font-weight-semibold"
            >
              <span>
                {t('facility-web.verify.code.para1')}
                <br />
                {t('facility-web.verify.code.para2')}
              </span>
            </p>
          ) : (
            <p className="is-rds-body-3 has-rds-font-weight-semibold">
              Enter the confirmation code that starts with a letter followed by
              9 numeric digits.
            </p>
          )}
          <form id="submit-code" onSubmit={onCodeSubmit}>
            <label htmlFor="code" className="is-rds-body-3">
              Code
            </label>
            <PartnerInput
              type="text"
              id="code"
              value={code}
              onChange={(e) => handleCodeChange(e)}
              className="has-rds-radius-4 has-rds-mt-8 has-rds-mb-24"
            />
            {memberCodeError && (
              <ErrorInfo message={t('facility-web.error.member-code')} />
            )}
            <PartnerButton data-testid="submit-code">Submit</PartnerButton>
          </form>
        </div>
      </div>
    </StyledCodeLookup>
  );
}

export default CodeLookup;
